import { InjectionToken } from '@angular/core';
import { AreasRegistry } from 'apps/account/src/account-shared';

// WS5 #10 Stage B B6 (THE ATOMIC CUT): the AngularJS-bridge bootstrap that used to live here
// (downgradeForAngularJS / downgradeDirective registering ng2→ngjs downgrade components +
// factories, and the environmentProvider config) is GONE with the AngularJS engine. The only
// surviving exports are these two InjectionTokens, consumed by the native nav-chrome providers
// (app.module.ts) + the *ftAreas directive — they resolve `AreasRegistry` instances via the
// Angular injector, never through AngularJS.
export const AREAS_REGISTRY = new InjectionToken<AreasRegistry>('AreasRegistry');
export const APP_MENU_AREAS_REGISTRY = new InjectionToken<AreasRegistry>('AppMenuAreasRegistry');
